import { moduleType } from "regen-api-ts-client";

import { buildBaseMapPath, buildModulePath } from "../../util/pathHelpers";
import { DATASOURCES, DEFAULT_DATASOURCE } from "../InteractiveMap/types";
import { MODULES } from "../modules/type";
import { TabContent } from "./types";

export const generateModuleTabContents = (
  farmId: string,
  fieldId: string,
  annum: number,
): TabContent[] => {
  const moduleTabs = MODULES.filter((module) => module.implemented).map(
    ({ id, name, icon }) => {
      if (id === moduleType.FIELD_PROPERTIES) {
        return {
          label: name,
          icon,
          route: buildBaseMapPath(
            farmId,
            annum,
            fieldId,
            DATASOURCES.ssurgo.id,
            DATASOURCES.ssurgo.defaultLayer?.id,
          ),
        };
      }
      return {
        label: name,
        icon,
        route: buildModulePath(farmId, annum, fieldId, id),
      };
    },
  );
  const mapTab = {
    label: "Map",
    icon: "/left-nav-icons/map.svg",
    route: buildBaseMapPath(
      farmId,
      annum,
      fieldId,
      DEFAULT_DATASOURCE.id,
      DEFAULT_DATASOURCE.defaultLayer?.id,
    ),
  };
  // Add map tab just below Home tab
  moduleTabs.splice(1, 0, mapTab);
  return moduleTabs;
};

export const adminTabContents: TabContent[] = [
  {
    label: "Farm List",
    route: "/admin",
    icon: "fa-house-lock",
  },
  {
    label: "Farm Map",
    route: "/admin/map",
    icon: "fa-map",
  },
  {
    label: "User List",
    route: "/admin/users",
    icon: "fa-users",
  },
  {
    label: "System Content",
    route: "/admin/system-content",
    icon: "fa-memo-pad",
  },
];
